module.exports = __webpack_public_path__ + "static/media/callingDisabled.d2bc4f7e.svg";